"use strict";

exports.__esModule = true;
exports.EventType = void 0;
var EventType = exports.EventType = /*#__PURE__*/function (EventType) {
  /**
   * 收集数据
   */
  EventType["collect"] = "collect";
  return EventType;
}({});